import mapboxgl from 'mapbox-gl';
import logger from '@/utils/logger';

/**
 * Loads Mapbox GL RTL text plugin once (Arabic, Hebrew, etc.).
 * The script is copied to public/plugins/ by postinstall (see scripts/copyMapboxRtl.js).
 */
export function ensureMapboxRtlTextPlugin() {
  try {
    if (!mapboxgl.getRTLTextPluginStatus || mapboxgl.getRTLTextPluginStatus() === 'unavailable') {
      const rtlUrl = `${import.meta.env.BASE_URL}plugins/mapbox-gl-rtl-text.js`;
      mapboxgl.setRTLTextPlugin(rtlUrl, null, true);
    }
  } catch (error) {
    logger.warn('Failed to enable Mapbox RTL text plugin:', error);
  }
}

/** Tailwind: hide Mapbox logo + attribution links inside map container. */
export const mapboxMapHideLogoClass = '[&_.mapboxgl-ctrl-logo]:hidden';
export const mapboxMapHideAttributionClass = '[&_.mapboxgl-ctrl-logo]:hidden [&_.mapboxgl-ctrl-attrib]:hidden';
